<template>
    <div 
        class="avatar"
        :class="{
            'avatar__sm': size === 'sm',
            'avatar__lg': size === 'lg',
        }" 
    >
        <img class="avatar__img" :src="src" alt=""/>
    </div>
</template>

<script>
export default {
    name: 'Avatar',
    props: {
        src: {
            type: String,
            default: () => ''
        },
        size: {
            type: String,
            default: () => 'sm'
        }
    }
}
</script>

<style lang="scss" scoped>
$radius: 50%;
$white: #ffffff;
.avatar {
    border: 1px solid $white;
    border-radius: $radius;
    overflow: hidden;
    &__sm {
        width: 64px;
        height: 64px;
    }
    &__lg {
        width: 80px;
        height: 64px;
    }
    &__img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
}
</style>
